import AuthorizeTransaction from "../authorize-transaction/AuthorizeTransaction";

const ReviewTransaction = () => {
  return <AuthorizeTransaction isTransactionHistory={true} />;
}

export default ReviewTransaction;